import { useEffect } from 'react';

const STORAGE_KEY = 'user_logged_in';

export function useCrossTabAuthSync() {
  useEffect(() => {
    const onStorage = (event: StorageEvent) => {
      if (event.key === STORAGE_KEY) {
        window.location.reload();
      }
    };

    window.addEventListener('storage', onStorage);

    return () => window.removeEventListener('storage', onStorage);
  }, []);
}
